export function mapStatesInNigeriaJSONtoOptions(states) {
    return states
        .map(({ state }) => state)
        .map(({ name: text, state_code: value }) => ({ text, value }))
}